import { useEffect } from 'react';

export const useGDLIBLoad = (cb: () => void, cleanUpCb?: () => void): void => {
  useEffect((): any => {
    if (window.__gdlib) {
      cb();
    } else {
      const listener = (e: MessageEvent): void => {
        if (e.data?.type === 'GD_ROOT_READY') {
          cb();
        }
      };

      window.addEventListener('message', listener);

      return () => {
        cleanUpCb?.();
        window.removeEventListener('message', listener);
      };
    }
  }, [cb]);
};
